module.exports = __webpack_public_path__ + "static/media/uno.c31957ab.jpg";